// src/hooks/useHiDPI.js
import { useEffect, useState } from 'react';

/**
 * Детектирует device‑pixel‑ratio > threshold.
 * • threshold по умолчанию 1.25  (≈ 125 % DPI или Browser Zoom)
 * • Автоматически обновляется, если окно утащили на другой монитор.
 * • Безопасен для SSR: на сервере всегда возвращает false.
 */
export default function useHiDPI(threshold = 1.25, enabled = true) {
    const getState = () =>
        enabled && typeof window !== 'undefined' && window.devicePixelRatio > threshold;

    const [isHiDPI, setIsHiDPI] = useState(getState);

    useEffect(() => {
        if (!enabled) {
            setIsHiDPI(false);
            return;
        }
        if (typeof window === 'undefined') return;          // SSR fallback
        const mq = window.matchMedia(`(resolution > ${threshold}dppx)`);
        const handler = e => setIsHiDPI(e.matches);
        setIsHiDPI(mq.matches);
        mq.addEventListener('change', handler);
        return () => mq.removeEventListener('change', handler);
    }, [threshold, enabled]);

    return isHiDPI;
}
